import { Service } from '@roc/feature-app-core';

const url = {
  EXTERNAL_AGENT_FORECLOSURE_LOANS: '/api/v1/loan/getExternalAgentForeclosureLoans',
  GET_COMPANY_INFORMATION: '/api/v1/loan/servicingVendor/getCompanyInformation',
  GENERATA_BANK_DETAILS_DOCUMENT: '/api/v1/loan/servicingVendor/generateBankDetailsDocument',
};

export class ExternalAgentLoanService extends Service {
  getExternalAgentForeclosureloans(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object
  ) {
    return this.get(
      url.EXTERNAL_AGENT_FORECLOSURE_LOANS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getCompanyInformation = (companyId) => {
    return this.get(`${url.GET_COMPANY_INFORMATION}?companyId=${companyId}`);
  };

  generateBankDetailsDocument(data) {
    return this.post(url.GENERATA_BANK_DETAILS_DOCUMENT, data);
  }

}
